const content: { [key: string]: any } = {
  teamList: 'Teams',
};

export default content;
